import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface PicflowMaintenanceService {
  getRealTimeMaintenanceMode: () => Observable<boolean>;
}

export const PICFLOW_MAINTENANCE = new InjectionToken<PicflowMaintenanceService>('PicflowMaintenanceService');
